var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClear48Filled = function SvgIconClear48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 7.3a16.7 16.7 0 1 0 16.7 16.7 16.72 16.72 0 0 0-16.7-16.7Zm7.58 21.87-2.4 2.4-5.18-5.17-5.17 5.17-2.4-2.4 5.17-5.17-5.17-5.18 2.4-2.4 5.17 5.17 5.18-5.17 2.4 2.4-5.17 5.18 5.17 5.17Z",
    fill: "current"
  })));
};
export default SvgIconClear48Filled;